import { Outlet } from "react-router-dom";
import { Integrations } from "./Integrations";
import { ConnectGoogleSheets } from "./GoogleSheets/ConnectGoogleSheets";

export const adminIntegrationsRoutes = [
    {
        path: "integrations",
        element: Outlet,
        children: [
            {
                path: "",
                element: Integrations,
            },
            {
                path: "google-sheet",
                element: ConnectGoogleSheets,
            },
        ],
    },
];
